import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import RouteInfo from '@ember/routing/-private/route-info';

export default class RouteHistoryService extends Service {
  @tracked previousRouteEnterTimestamp: number | null = null;
  @tracked previousRouteName: string | null = null;
  @tracked previousRoute: RouteInfo | null = null;

  @action
  setPreviousRoute(previousRouteEnterTimestamp: number, previousRouteName: string, previousRoute: RouteInfo) {
    this.previousRouteEnterTimestamp = previousRouteEnterTimestamp;
    this.previousRouteName = previousRouteName;
    this.previousRoute = previousRoute;
  }
}

declare module '@ember/service' {
  interface Registry {
    'route-history': RouteHistoryService;
  }
}
